import { useTranslation } from 'react-i18next';
import { useMe, useUpdateProfile } from '@/features/shell/queries';

/**
 * Whether the weekly reminder arrives, said where the checklist is.
 *
 * Here rather than on a settings page, because this is the thing it is about: the
 * person deciding whether to be emailed about the checklist is looking at the
 * checklist. There is no settings page to put it on, and inventing one to hold a
 * single switch would hide it.
 *
 * **Absent means on.** The field arrived after the first profiles were written, so
 * a missing value is an old profile and not a choice — the same reading the sender
 * uses, and the two have to agree or the switch would show off for somebody who
 * is still being mailed.
 */
export function WeeklyReminderToggle() {
  const { t } = useTranslation();
  const me = useMe();
  const save = useUpdateProfile();

  if (!me.data) return null;
  const on = me.data.profile.weeklyEmail !== false;

  return (
    <label className="flex items-start gap-3 text-body">
      <input
        type="checkbox"
        checked={on}
        onChange={(e) => save.mutate({ weeklyEmail: e.target.checked })}
        className="mt-1 size-4 shrink-0 accent-leaf"
      />
      <span>
        {t('tasks.weeklyEmail')}
        <span className="block text-caption text-leaf-soft">{t('tasks.weeklyEmailHint')}</span>
      </span>
    </label>
  );
}
